import React from "react";
import menuIcon from "../../Assests/icons/panel-right-close.svg";
import "./style.css";

const Navbar = ({ title, collapsed, setCollapsed }) => {
  return (
    <div className="navbar">
      <div className="header-wrapper">
        <div className="collapser">
          <img
            className="panel-icon"
            src={menuIcon}
            alt="Toggle Sidebar"
            onClick={() => setCollapsed(!collapsed)}
          />
        </div>
        <div className="title">{title}</div>
      </div>
      <div className="divider"></div>
    </div>
  );
};

export default Navbar;
